<template>
  <div class="inspection-main">
    <div class="inspection-wrap">
      <header class="header">
        <div class="header-1"></div>

        <div class="header-2">
          <div class="logo">
            <img src="https://renhe-platform-pre.oss-cn-shanghai.aliyuncs.com/2025-04-28/1745819464041_header-title-bj.png" />
          </div>
        </div>
      </header>

      <div class="content">
        <div class="content-form">
          <el-form ref="formRef" :model="formData" :rules="formRules" @submit.prevent label-width="367" autocomplete="new-password">
            <el-form-item label="统一社会信用代码/注册号" prop="regCode" inline-message>
              <el-input v-model.trim="formData.regCode" autocomplete="new-password" />
            </el-form-item>

            <el-form-item label="法定代表人（负责人）姓名" prop="legalName">
              <el-input v-model.trim="formData.legalName" autocomplete="new-password" />
            </el-form-item>

            <el-form-item label="法定代表人（负责人）证件号码" prop="legalId">
              <el-input v-model.trim="formData.legalId" autocomplete="new-password" />
            </el-form-item>

            <el-form-item label="密码" prop="password">
              <el-input v-model.trim="formData.password" maxlength="20" type="password" show-password autocomplete="new-password" />
            </el-form-item>

            <el-form-item label="确认密码" prop="password2">
              <el-input v-model.trim="formData.password2" maxlength="20" type="password" show-password autocomplete="new-password" />
            </el-form-item>

            <el-form-item label="工商联络员姓名" prop="userName">
              <el-input v-model.trim="formData.userName" autocomplete="new-password" />
            </el-form-item>

            <el-form-item label="联络员证件类型" prop="userType">
              <el-select v-model.trim="formData.userType">
                <el-option v-for="(item, index) of userTypeOptions" :key="index" :label="item.label" :value="item.value" />
              </el-select>
            </el-form-item>

            <el-form-item label="联络员证件号码" prop="cardId">
              <el-input v-model.trim="formData.cardId" autocomplete="new-password" />
            </el-form-item>

            <el-form-item label="联络员手机号码" prop="userMobile">
              <el-input v-model.trim="formData.userMobile" maxlength="11" :formatter="(value) => value.replace(/[^\d]/g, '')" autocomplete="new-password" />
            </el-form-item>

            <el-form-item label="验证码" prop="verifyCode">
              <el-row :gutter="10">
                <el-col :span="14">
                  <el-input v-model.trim="formData.verifyCode" maxlength="5" autocomplete="new-password" />
                </el-col>
                <el-col :span="10">
                  <div class="el-col-verifyCode">
                    <img src="https://renhe-platform-pre.oss-cn-shanghai.aliyuncs.com/2025-04-28/1745828526260_checkCodeServlet.jpg" />
                    <el-button type="primary" link>换一张</el-button>
                  </div>
                </el-col>
              </el-row>
            </el-form-item>
          </el-form>
        </div>

        <div class="content-btn">
          <el-button type="primary" @click="formSubmit">验证&保存</el-button>
          <el-button type="primary" @click="gotoPage('login')">返回登录页</el-button>
        </div>
      </div>
    </div>

    <div class="inspection-footer">
      <div class="con">
        <div class="con1">
          <img src="https://renhe-platform-pre.oss-cn-shanghai.aliyuncs.com/2025-04-28/1745822382403_shibie.png" />
          <img src="https://renhe-platform-pre.oss-cn-shanghai.aliyuncs.com/2025-04-28/1745822412493_jiucuo.png" />
        </div>

        <div class="con2">
          <div class="link"><span>站点地图</span>|<span>关于我们</span>|<span>建议意见</span>|<span>法律声明</span>|<span>联系我们</span></div>
          <p>主办：北京市市场监督管理局 承办：北京市市场监督管理局 地址：北京市通州区留庄路6号院1号楼 邮政编码：101117</p>
          <div class="text">
            <p>政府网站标识码：1100000065</p>
            <p>京公网安备 11040102700026</p>
            <p>京ICP备19008898号-3</p>
          </div>
          <p>
            业务咨询与技术支持联系方式， 服务时间：周一至周日9点-17点 （国家法定节假日除外）<br />
            扫描右侧二维码，关注微信公众账号“企业年报系统技术支持”，获取在线支持
          </p>
          <p class="tip">温馨提示：请使用IE8.0以上浏览器、360浏览器、firefox浏览器</p>
        </div>

        <ul class="con3">
          <li>
            <img src="https://renhe-platform-pre.oss-cn-shanghai.aliyuncs.com/2025-04-28/1745822787974_gfwx.jpg" />
            <p>官方微信</p>
          </li>

          <li>
            <img src="https://renhe-platform-pre.oss-cn-shanghai.aliyuncs.com/2025-04-28/1745822852481_gfwb.jpg" />
            <p>官方微博</p>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script setup>
import { cloneDeep } from "lodash";
import { $emit, $on } from "vue-happy-bus";

const props = defineProps({
  inspectionData: {
    required: true,
    type: Object,
  },
});

const formData = ref({});

const formRules = {
  regCode: [
    {
      required: true,
      message: "统一社会信用代码/注册号不能为空",
      trigger: ["blur", "change"],
    },
  ],
  legalName: [
    {
      required: true,
      message: "法定代表人（负责人）姓名不能为空",
      trigger: ["blur", "change"],
    },
  ],
  legalId: [
    {
      required: true,
      message: "法定代表人（负责人）证件号码不能为空",
      trigger: ["blur", "change"],
    },
  ],
  password: [
    {
      required: true,
      message: "密码不能为空",
      trigger: ["blur", "change"],
    },
  ],
  password2: [
    {
      validator: (rule, value, callback) => {
        if (!value) {
          callback(new Error("确认密码不能为空"));
        } else if (value !== formData.value.password) {
          callback(new Error("确认密码与密码不一致"));
        } else {
          callback();
        }
      },
      trigger: ["blur", "change"],
    },
  ],
  userName: [
    {
      required: true,
      message: "工商联络员姓名不能为空",
      trigger: ["blur", "change"],
    },
  ],
  userType: [
    {
      required: true,
      message: "联络员证件类型不能为空",
      trigger: ["blur", "change"],
    },
  ],
  cardId: [
    {
      required: true,
      message: "联络员证件号码不能为空",
      trigger: ["blur", "change"],
    },
  ],
  userMobile: [
    {
      required: true,
      message: "联络员手机号码不能为空",
      trigger: ["blur", "change"],
    },
  ],
  verifyCode: [
    {
      required: true,
      message: "验证码不能为空",
      trigger: ["blur", "change"],
    },
  ],
};

const formRef = ref();
const formSubmit = () => {
  formRef.value.validate((isValid) => {
    if (isValid) {
      const inspectionDataClone = cloneDeep(props.inspectionData);
      inspectionDataClone.formDataRegister = formData.value;
      $emit("inspectionSubmit", inspectionDataClone);
      gotoPage("login");
    }
  });
};

const formReset = () => {
  formRef.value.resetFields();
};

const emits = defineEmits(["gotoPage"]);

const gotoPage = (page) => {
  emits("gotoPage", page);
};

const userTypeOptions = [
  { label: "中华人民共和国居民身份证", value: "1" },
  { label: "士兵证", value: "2" },
  { label: "军官证", value: "3" },
  { label: "警官证", value: "4" },
];
</script>

<style scoped lang="scss">
.inspection-main {
  background-color: #fbf8ef;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  min-height: 100%;

  .inspection-wrap {
    overflow: hidden;
    flex-shrink: 0;

    .header {
      padding: 8px;

      .header-1 {
        width: 1300px;
        height: 80px;
        margin: auto;
        background: url(https://renhe-platform-pre.oss-cn-shanghai.aliyuncs.com/2025-04-28/1745818717452_header-title-bjscj.png) 0% center no-repeat;
        background-position: 0% center;
      }

      .header-2 {
        border-top: 11px solid rgb(189, 26, 45);
        height: 109px;
        background: #ffffff url(https://renhe-platform-pre.oss-cn-shanghai.aliyuncs.com/2025-04-28/1745818808900_bj.png) no-repeat right top;

        .logo {
          width: 1100px;
          margin: 0 auto;
          height: 100%;
          display: flex;
          align-items: center;
        }
      }
    }

    .content {
      width: 1121px;
      background-color: #ffffff;
      margin: 40px auto;
      border: 10px solid #ca9a37;
      overflow: hidden;
      padding: 33px 25px 25px;

      .content-form {
        border: 1px solid rgb(239, 239, 239);

        :deep(.el-form-item) {
          height: 42px;
          margin-bottom: 0;

          &:not(:nth-last-of-type(1)) {
            border-bottom: 1px solid rgb(239, 239, 239);
          }

          .el-form-item__label {
            height: 42px;
            background-color: #eae3db;
            color: #93550f;
            align-items: center;
          }

          .el-form-item__content {
            padding-left: 60px;
            padding-right: 260px;
            background-color: #f7f8fa;

            .el-input {
              input {
                line-height: normal;
              }
            }
          }

          .el-form-item__error {
            left: unset;
            right: 10px;
            top: 50%;
            margin-top: -7px;
            padding: 0;
          }

          .el-col-verifyCode {
            display: flex;
            align-items: center;
            justify-content: space-between;
            height: 100%;

            img {
              cursor: pointer;
            }

            .el-button {
              color: rgb(0, 0, 238);
            }
          }
        }
      }

      .content-btn {
        display: flex;
        justify-content: center;
        align-items: center;
        margin-top: 20px;

        .el-button {
          background-color: #ab812d;
          border-color: #ab812d;
        }
      }
    }
  }

  .inspection-footer {
    border-top: 1px solid #d5d5d5;
    width: 100%;
    background-color: rgb(189, 26, 45);
    padding-bottom: 12px;

    .con {
      width: 937px;
      margin: 0px auto;
      text-align: center;
      display: flex;
      justify-content: space-between;
      align-items: flex-start;

      .con1 {
        margin-top: 32px;
        display: flex;
        cursor: pointer;
        align-items: center;

        img {
          flex: 0 0 auto;

          &:nth-of-type(1) {
            margin: 5px;
          }
        }
      }

      .con2 {
        font-size: 12px;
        padding: 20px 20px 0 20px;

        .link {
          display: flex;
          align-items: center;
          justify-content: center;

          span {
            cursor: pointer;
            margin: 0 3px;
          }
        }

        .text {
          display: flex;
          align-items: center;
          justify-content: space-between;
          padding: 0px 18px;
        }

        .tip {
          font-weight: bold;
        }
      }

      .con3 {
        margin-top: 20px;
        margin-right: 15px;
        display: flex;
        align-items: center;

        > li {
          &:not(:nth-of-type(1)) {
            margin-left: 4px;
          }

          img {
            width: 90px;
            height: 85px;
          }
        }
      }
    }
  }
}
</style>
